var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { createRoot } from "react-dom/client";
import * as firebase from "./firebase";
const PhraGen = () => {
    const [phrase, setPhrase] = React.useState("");
    const fetchPhrase = () => __awaiter(void 0, void 0, void 0, function* () {
        const ret = yield firebase.functions.generate();
        setPhrase(ret);
    });
    React.useEffect(() => {
        fetchPhrase();
    }, []);
    const onClick = (e) => {
        const target = e.currentTarget;
        switch (target.name) {
            case "regenerate":
                fetchPhrase();
                break;
            case "copyRaw":
                copyRaw(phrase);
                break;
            case "copyWithoutWhiteSpace":
                copyWithoutWhiteSpace(phrase);
                break;
            default:
                break;
        }
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "content" },
            React.createElement("button", { className: "button is-primary is-medium", name: "regenerate", onClick: onClick }, "Push to re-generate a phrase")),
        React.createElement("div", { className: "content" },
            React.createElement("div", { style: { fontSize: "large" } }, "generated phrase:"),
            React.createElement("div", { style: { fontSize: "x-large" } }, phrase)),
        React.createElement("button", { className: "button is-info is-medium", name: "copyRaw", onClick: onClick }, "Copy to clipboard"),
        "\u00A0",
        React.createElement("button", { className: "button is-info is-medium", name: "copyWithoutWhiteSpace", onClick: onClick }, "Copy to clipboard (without whitespace)")));
};
const copyRaw = (str) => {
    copyText(str);
};
const copyWithoutWhiteSpace = (str) => {
    copyText(str.replace(/\s+/g, ""));
};
const copyText = (str) => {
    var _a;
    const tmp = document.createElement("div");
    tmp.appendChild(document.createElement("pre")).textContent = str;
    const s = tmp.style;
    s.position = "fixed";
    s.left = "-100%";
    document.body.appendChild(tmp);
    (_a = document.getSelection()) === null || _a === void 0 ? void 0 : _a.selectAllChildren(tmp);
    document.execCommand("copy");
    document.body.removeChild(tmp);
};
createRoot(document.getElementById("phrase")).render(React.createElement(PhraGen, null));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 13
// module chunks = 0